/* eslint-disable */
import React from "react";
import { Link } from "react-router-dom";

const TabsHeader = ({ commonHeaderObject, activeOption }) => {
  const activeStyle = {
    color: '#EE523C',
    borderBottom: '3px solid #EE523C'
  };

  const inactiveStyle = {
    color: '#6c757d',
    borderBottom: '3px solid transparent'
  };

  return (
    <div className="inner-menu-container bg-white shadow-sm">
      <div className="container-fluid px-lg-5">
        <ul className="nav secondary-menu mw-100 flex-nowrap gap-1 gap-sm-2 gap-lg-3 flex-fill fs-sm fw-semibold text-center border-0 text-nowrap overflow-auto">
          {/* ------- map loop -------- */}
          {commonHeaderObject.map((item, index) => {
            const isActive = item.title === activeOption;
            return (
              <li key={index} className="nav-item flex-fill">
                <Link
                  to={item.link}
                  className={`d-block px-2 px-sm-3 py-3 py-sm-4 position-relative ${
                    isActive && "active"
                  }`}
                  style={isActive ? activeStyle : inactiveStyle}
                >
                  {item.title}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default TabsHeader;
